// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-timeline__logo{position:absolute;width:25px;height:25px;margin-top:-2px;border-radius:20%}[dir=ltr] .provider-timeline__logo{left:-15px}[dir=rtl] .provider-timeline__logo{right:-15px}.provider-timeline__titles{margin-inline-start:35px}", ""]);
// Exports
module.exports = exports;
